/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { IAddContactInfo, ICheckoutGuestProfileViewProps, IShowContactInfo } from './dlvry-checkout-v2-guest-profile';

export const ShowContactInfo: React.FC<IShowContactInfo> = ({
    baseClassName,
    showInfoProps,
    emailLabel,
    email,
    editButton,
    customerRequisitionLabel,
    customerRequisition,
    customerReferenceLabel,
    customerReference,
    customerMessageLabel,
    customerMessage
}) => (
    <Node {...showInfoProps}>
        <Node className={`${baseClassName}__split`}>
            <Node className={`${baseClassName}__left`}>
                <Node className={`${baseClassName}__email`}>
                    {emailLabel}
                    {email}
                </Node>
                <Node className={`${baseClassName}__req-and-ref`}>
                    <Node className={`${baseClassName}__req`}>
                        {customerRequisitionLabel}
                        {customerRequisition}
                    </Node>
                    <Node className={`${baseClassName}__ref`}>
                        {customerReferenceLabel}
                        {customerReference}
                    </Node>
                </Node>
            </Node>
            <Node className={`${baseClassName}__right`}>
                {customerMessageLabel}
                {customerMessage}
            </Node>
        </Node>
        {editButton}
    </Node>
);

export const AddContactInfo: React.FC<IAddContactInfo> = ({
    addFormProps,
    baseClassName,
    submitButton,
    cancelButton,
    inputGroupProps,
    label,
    error,
    input,
    customerReferenceInput,
    customerRequisitionInput,
    customerReferenceLabel,
    customerRequisitionLabel,
    customerMessageLabel,
    customerMessageInput,
    customerSupportingText
}) => (
    <Node {...addFormProps}>
        <Node className={`${baseClassName}__split`}>
            <Node className={`${baseClassName}__left`}>
                <Node className={`${baseClassName}__email`}>
                    {label}
                    {input}
                </Node>
                <Node className={`${baseClassName}__req-and-ref`}>
                    <Node className={`${baseClassName}__req`}>
                        {customerRequisitionLabel}
                        {customerRequisitionInput}
                    </Node>
                    <Node className={`${baseClassName}__ref`}>
                        {customerReferenceLabel}
                        {customerReferenceInput}
                    </Node>
                </Node>
            </Node>
            <Node className={`${baseClassName}__right`}>
                {customerMessageLabel}
                {customerMessageInput}
            </Node>
        </Node>
        <Node className={`${baseClassName}__bottom`}>
            {error || <span></span>}
            {customerSupportingText}
        </Node>
        {submitButton}
        {cancelButton}
    </Node>
);

const CheckoutGuestProfileView: React.FC<ICheckoutGuestProfileViewProps> = ({
    moduleProps,
    checkoutErrorRef,
    alert,
    showContactInfo,
    addContactInfo
}) => {
    return (
        <Module {...moduleProps} ref={checkoutErrorRef}>
            {alert}
            {showContactInfo && <ShowContactInfo {...showContactInfo} />}
            {addContactInfo && <AddContactInfo {...addContactInfo} />}
        </Module>
    );
};

export default CheckoutGuestProfileView;
